export const routes = {
    //common routes
    auth_response: "/authresp",
    accept_terms: "/accept-terms",
    base_url: "/",
    login_url: "/login",

    //assessment routes
    view_assessment: "/assessments-library",
    view_assessment_pass_info: ({isPublic})=>({
        state:{
            isPublic:isPublic
        }
    }),
    finalize: "/finalize",
    setup_assessment: "/setup-assessment",
    student_view: "/student-view",
    grade: "/grade",
    grade_report: "/grade-report",
    teacher_grade_report: "/teacher-grade-report",
    settings_view: "/assessment-settings",
    settings_hierarchy: "/hierarchy-settings",

    //question routes
    questions_library: "/questions-library",
    new_question: "/new-question",
    create_question: "/create-question",
    edit_question: "/edit-question",
    finalize_new_question: "/finalize-new-question",

    //manage routes
    admin_url: "/admin",
    teacher_url: "/teacher",
    sign_in_url: "/sign-in",
    profile: "/profile",

    aehs:"/aehs",
    aehsreg:"/aehsreg",

    manage_teacher: "/manage-teacher",
    manage_reg_b_teacher: "/manage-reg-b-teacher",
    manage_student: "/manage-student",
    manage_cgc_student: "/manage-cgc-student",
    manage_reg_b_student: "/manage-reg-b-student",
    manage_reg_c_student: "/manage-reg-c-student",
    manage_admin: "/manage-admin",
    manage_parent: "/manage-parent",

    manage_invitations: "/manage-invitations",
    manage_dashboard: "/manage-dashboard",
    manage_enrollment: "/manage-enrollment",
    manage_enrollment_b: "/manage-enrollment_b",
    manage_teacher_enrollment: "/manage-teacher-enrollment",
    manage_attendance: "/manage-attendance",
    manage_about: "/manage-about",
    manage_about_b: "/manage-about-b",
    manage_organization_attribute: "/manage-organization-attribute",
    manage_search: "/manage-search",
    calendar_app: "/calendar-app",
    main_calendar: "/main-calendar",
    feedback_form: "/feedback-form",

    //cgc profile
    student_profile: '/student-profile',

    //reg_b profile
    reg_b_student_profile: '/reg-b-student-profile',

    paper_list: "/paper-list",
    paper_mapping: "/paper-mapping",

    form_attachment: "/form-attachment",
    manage_form: "/manage-form",
    manage_node: "/manage-node",
    user_list: "/user-list",

    manage_evaluate_b: "/evaluate_b",
    manage_evaluate_a: "/evaluate_a",


    manage_documents: "/manage-documents",
    manage_admin_documents: "/manage-admin-documents",
    manage_videos: "/manage-videos",
    manage_marksheet: "/manage-marksheet",
    manage_announcement: "/manage-annonucement",
    announcements: "/announcements",

    payment_gateway: "/payment-gateway",
    manage_payment: "/manage-payment",
    manage_zoom: "/manage-zoom",
    manage_subscription_main: "/manage-subscription-main",

    quiz_mapping: "/quiz-mapping",
    manage_settings: "/manage-settings",
    manage_sitemap: "/manage-sitemap",
    manage_staff: "/manage-staff",
    manage_chat: "/manage-chat",
    manage_progress: "/manage-progress",
    manage_crm: "/manage-crm",


    register_student: "/register-student",
    my_requests: "/my-requests",
    parent_student_signup:"/parent-student-signup",
    registration_form_view: "/register",
    terms_and_conditions_view_from_registration_form: "/terms-and-conditions",
    terms_and_conditions_view: "/conditions",

    //candidate routes
    enrolled_paper_list: "/enrolled-paper-list",
    paper_details: "/paper-details",
    self_grade: "/self-grade",
    paper_grade_report: "/paper-grade-report",
    paper_auto_grade_report: "/paper-auto-grade-report",
    view_question_paper: "/view-question-paper",
    paper_review: "/paper-review",
    subscriptions: "/subscriptions",

    manage_teacher_payments: "/manage-teacher-payments",

    manage_meetings: "/manage-meetings",
}